// ** React Import
import { useState, memo } from "react";
import { useNavigate, Link } from "react-router-dom";

// ** Icon Imports
import Icon from "../../../components/icon";

// ** Third Party Imports
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

// ** Custom Components Imports
import OptionsMenu from "../../../components/option-menu";
import { useUnsavedChanges } from "../../../components/UnsavedChangesContext";
import UnsavedChangesDialog from "components/UnsavedChangesDialog";

const SettingsDropdown = memo(() => {
  const [anchorEl, setAnchorEl] = useState(null);

  const MySwal = withReactContent(Swal);
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState("1");
  const [isChanged, setIsChanged] = useState(false);
  const { setHasUnsavedChanges, hasUnsavedChanges } = useUnsavedChanges();
  const [openUnsavedChangesDlg, setOpenUnsavedChangesDlg] = useState(false);
  const [unsavedDialogAction, setUnsavedDialogAction] = useState({
    action: "",
    tabValue: "",
  });
  const handleOpenUnsavedChangesDlg = (action, tabValue) => {
    if (action === "tabChange") {
      setUnsavedDialogAction({
        action: action,
        tabValue: tabValue,
      });
    } else {
      setUnsavedDialogAction({
        action: action,
        tabValue: "",
      });
    }
    setOpenUnsavedChangesDlg(true);
  };
  const handleCloseUnsavedChangesDlg = () => setOpenUnsavedChangesDlg(false);
  const handleDiscardChanges = () => {
    setHasUnsavedChanges(false);
    setOpenUnsavedChangesDlg(false);
    navigate("/settings");
  };

  const handleOpen = (event) => {
    const target = event.currentTarget;
    if (hasUnsavedChanges) {
      handleOpenUnsavedChangesDlg("navigate");
    } else {
      setHasUnsavedChanges(false);
      navigate("/settings");
    }
  };
  //  handleOpenDlg();
  // MySwal.fire({
  //   title: "Are you sure?",
  //   html: "This page has unsaved changes",

  //   showCancelButton: true,
  //   confirmButtonColor: "#23A26D",
  //   cancelButtonColor: "#d33",
  //   confirmButtonText: "Discard Changes",
  //   cancelButtonText: "Cancel",
  //   allowEscapeKey: true,
  // }).then((result) => {
  //   if (result.isConfirmed) {
  //     setAnchorEl(target)
  //   }
  //   });
  //       }else{
  //         handleCloseDlg();
  //         setAnchorEl(target)
  //       }
  // }
  const [open, setOpen] = useState(false);
  const handleClose = () => setAnchorEl(null);
  const handleOpenDlg = () => setOpen(true);
  const handleCloseDlg = () => setOpen(false);
  const handleDiscard = () => {
    handleCloseDlg();
    setHasUnsavedChanges(false);
  };

  return (
    <>
      <OptionsMenu
        iconButtonProps={{
          color: "inherit",
          onClick: handleOpen,
        }}
        icon={<Icon fontSize="1.625rem" icon="tabler:settings" />}
        menuProps={{
          open: Boolean(anchorEl),
          anchorEl: anchorEl,
          onClose: handleClose,
          sx: { "& .MuiMenu-paper": { mt: 4.25, minWidth: 130 } },
        }}
        options={[
          {
            text: "Option 1",
            menuItemProps: {
              sx: { py: 2 },
              // onClick: () => {

              // }
            },
          },
          {
            text: "Option 2",
            menuItemProps: {
              sx: { py: 2 },
            },
          },
          {
            text: "Option 3",
            menuItemProps: {
              sx: { py: 2 },
            },
          },
        ]}
      />
      <UnsavedChangesDialog
        open={openUnsavedChangesDlg}
        handleClose={handleCloseUnsavedChangesDlg}
        handleDiscard={handleDiscardChanges}
      />
      <UnsavedChangesDialog
        open={open}
        onClose={handleCloseDlg}
        onDiscard={handleDiscard}
      />
    </>
  );
});

SettingsDropdown.displayName = 'SettingsDropdown';
export default SettingsDropdown;
